import { render } from "./AnswerBankTech.vue?vue&type=template&id=58e515a2&scoped=true"
import script from "./AnswerBankTech.vue?vue&type=script&lang=js"
export * from "./AnswerBankTech.vue?vue&type=script&lang=js"

import "./AnswerBankTech.vue?vue&type=style&index=0&id=58e515a2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e515a2"]])

export default __exports__